import { render } from "./En009.vue?vue&type=template&id=85b675f2"
import script from "./En009.vue?vue&type=script&lang=js"
export * from "./En009.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__